let Test = require('@/mixins/Forms/2019/NRCA_LTI_03_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            disabledThirdStage: false,
            functional_test: {
                name: `Functional Testing (NA7.6.1.2.2)`,
                zones: [],
                steps: {
                    step_1: {
                        name: `Step 1: Identify the reference location (the minimum daylighting location in the controlled zone). (NA7.6.1.2.2(a)) For parking garages, illuminance levels should be measured at the farthest edge of the secondary sidelit zone away from the glazing or opening. (Section 130.1(d)3D)`,
                        questions: {
                            question_1: {
                                id: `a`,
                                type: 'Option',
                                question: `Specify the control type: stepped dimming (<b>SD</b>) or stepped switching (<b>SW</b>)`,
                                options: [
                                    'SD',
                                    'SW',
                                ],
                                zones: []
                            },
                            question_2: {
                                id: `b`,
                                type: 'Option',
                                question: `Specify the power estimation method to be used: counting (<b>C</b>) – only for stepped switching, cut sheet (<b>CS</b>) - ballast cut sheet with steps of power and light must be attached, measured Amps multiplied by Volts (<b>VA</b>), or measured watts (<b>W</b>)`,
                                options: [
                                    // 'C',
                                    'CS',
                                    'VA',
                                    'W',
                                ],
                                zones: []
                            }
                        }
                    },
                    step_2: {
                        name: `Step 2: No daylight test. Simulate or provide conditions without daylight. (NA7.6.1.2.2(b))`,
                        questions: {
                            question_1: {
                                id: `c`,
                                type: 'Option',
                                question: `Indicate the method used to simulate or provide conditions without daylight: night time manual measurement (<b>Night</b>), night time illuminance logging (<b>Log</b>) - attach plot of illuminance or power, cover fenestration (<b>CF</b>), or cover photosensor (<b>CP</b>)`,
                                options: [
                                    'Night',
                                    'Log',
                                    'CF',
                                    'CP',
                                ],
                                zones: []
                            },
                            question_2: {
                                id: `d`,
                                type: 'Float',
                                question: `Enter the reference illuminance value in footcandles (fc), as measured at the reference location. This is the electric lighting illuminance level without any daylight. (NA7.6.1.2.2(b)4)`,
                                zones: []
                            },
                            question_3: {
                                id: `e`,
                                type: 'String',
                                question: `Enter the measured Amps multiplied by Volts in Volt-Amps (VA) if power estimation method (line b) = VA. <br> <b>OR</b> Enter the measured watts (W) if power estimation method (line b) = W.<br> <b>OR</b> Indicate not applicable (N/A) if power estimation method (line b) = C or CS`,
                                zones: [],
                            },
                            question_4: {
                                id: `f`,
                                type: 'Boolean',
                                question: `Automatic daylight control system turns on all stages of controlled lights unless it is documented that multi-level luminaires have been tuned to less than full output and the design illuminance levels are provided. (NA7.6.1.2.2(b)2)`,
                                zones: []
                            },
                            question_5: {
                                id: `g`,
                                type: 'Option',
                                question: `The stepped dimming control system provides reduced flicker over the entire operating range as specified by §110.9. (NA7.6.1.2.2(b)3) Enter yes (<b>Y</b>) or no (<b>N</b>). <br><b>OR</b> Indicate not applicable (<b>N/A</b>) if control type (line a) = SW`,
                                options: [
                                    'Yes',
                                    'No',
                                    'N/A',
                                ],
                                zones: []
                            },
                        }
                    },
                    step_3: {
                        name: `Step 3: Full daylight test. Simulate or provide bright conditions where the daylight illuminance is greater than 150% of the reference illuminance measured in Step 2. (NA7.6.1.2.2(c), Section 130.1(d)3C, Section 130.1(d)3D)`,
                        questions: {
                            question_1: {
                                id: `h`,
                                type: 'Float',
                                question: `Enter the daylight illuminance (light level with the electric lighting turned off) value in footcandles (fc) measured at the reference location`,
                                zones: []
                            },
                            question_2: {
                                id: `i`,
                                type: 'Percentage',
                                question: `Calculate the ratio of daylight illuminance to the reference illuminance in %. ([line h / line d] x 100)`,
                                zones: []
                            },
                            question_3: {
                                id: `j`,
                                type: 'BooleanResult',
                                question: `The ratio of daylight illuminance to the reference illuminance (line i) is greater than 150%. (Section 130.1(d)3C, Section 130.1(d)3D)`,
                                zones: []
                            },
                            question_4: {
                                id: `k`,
                                type: 'String',
                                question: `Enter the measured system power in Volt-Amps (VA) or watts (W) if power estimation method (line b) = VA or W.<br> <b>OR</b> Indicate not applicable (N/A) if power estimation method (line b) = C or CS`,
                                zones: []
                            },
                            question_5: {
                                id: `l`,
                                type: 'String',
                                question: `Enter the fraction of system wattage turned off in % if the power estimation method (line b) = C. <br> <b>OR</b> Indicate not applicable (<b>N/A</b> ) if the power estimation method (line b) = CS, VA, or W`,
                                zones: []
                            },
                            question_6: {
                                id: `m`,
                                type: 'PercentageInput',
                                question: `Enter the power reduction of dimmed lamps calculated from the manufacturer's cut sheet if the power estimation method (line b) = CS. <br> <b>OR</b> Indicate not applicable (<b>N/A</b> ) if the power estimation method (line b) = C, VA, or W.<br>Enter value as decimal (ex .15 for 15%)`,
                                zones: []
                            },
                            question_7: {
                                id: `n`,
                                type: 'Percentage',
                                question: `Calculate the system power reduction in %.<br> If power estimation method (line b) = C, system power reduction = fraction of system wattage turned off (line l). <b>OR</b><br> If power estimation method (line b) = CS, system power reduction = power reduction of dimmed lamps (line m). <b>OR</b><br> If power estimation method (line b) = VA or W, system power reduction = [1 - measured system power at dimmed stage (line k)/full load system power (line e)].`,
                                zones: [],
                            },
                            question_8: {
                                id: `o`,
                                type: 'BooleanResult',
                                question: `For areas other than parking garages, the system lighting power reduction of the controlled luminaires (line n) is at least 65%. (NA7.6.1.2.2(c)1, Section 130.1(d)3C) <br> <b>OR</b> For parking garages, the controlled lighting power consumption is zero. (Section 130.1(d)3D)`,
                                zones: []
                            },
                            question_9: {
                                id: `p`,
                                type: 'Boolean',
                                question: `Only the luminaires in the daylit zones are affected by daylight control. (NA7.6.1.2.2(c)2)`,
                                zones: []
                            },
                            question_10: {
                                id: `q`,
                                type: 'Option',
                                question: `If a PAF is claimed for daylight dimming plus OFF controls, the system automatically turns off the luminaires that are receiving this credit. (Section 140.6(a)2H) Enter yes (<b>Y</b>), no (<b>N</b>), or not applicable (<b>N/A</b>).`,
                                options: [
                                    'Yes',
                                    'No',
                                    'N/A',
                                ],
                                zones: []
                            },
                        }
                    },
                    step_4: {
                        name: `Step 4: Partial daylight test. For each control stage tested in this step, the control stages with lower setpoints than the staged tested are left on and those stages of control with higher setpoints are dimmed or controlled off. Simulate or provide conditions so that each control stage turns on and off or dims. (NA7.6.1.2.2(d))`,
                        questions: {
                            question_1: {
                                id: `r`,
                                question: `Enter the number of control steps between ON and OFF. If the control has 1 to 3 steps, all control stages must be tested. If the control has more than 3 steps, testing 3 control stages is sufficient for showing compliance. (NA7.6.1.2.2) If the control has 0 steps between ON and OFF, the partial daylight test is not necessary.`,
                                type: 'Float',
                                zones: []
                            },
                            question_1_1: {
                                id: ``,
                                type: 'Boolean',
                                question: `There  are 0 control steps between ON and OFF?`,
                                zones: []
                            },
                            question_2: {
                                id: `s`,
                                question: `Indicate method used to simulate or provide conditions with partial daylight: natural daylight manual measurement (<b>ND</b>), light logging (<b>Log</b>), partially cover
                                            fenestration (<b>PCF</b>), open loop setpoint adjustment (<b>OLSA</b>)`,
                                type: 'Option',
                                options: [
                                    'ND',
                                    'Log',
                                    'PCF',
                                    'OLSA'
                                ],
                                zones: []
                            },
                            question_2_1: {
                                type: 'Text',
                                text: `First stage of control (partial daylight test)`,
                            },
                            question_3: {
                                id: `t`,
                                type: 'Float',
                                question: `Enter the total illuminance (combined daylight and electric light illuminance) in footcandles (fc) measured at the reference location just after the first stage of control dims or shuts off a stage of lighting (NA7.6.1.2.2(d)1)`,
                                zones: []
                            },
                            question_4: {
                                id: `u`,
                                type: 'BooleanResult',
                                question: `The total illuminance (line t) is greater than or equal to the reference illuminance (line d). (NA7.6.1.2.2(d)1A, Section 130.1(d)3B)`,
                                zones: []
                            },
                            question_5: {
                                id: `v`,
                                type: 'Percentage',
                                question: `Calculate the ratio of total illuminance to the reference illuminance in %. ([line t / line d] x 100)`,
                                zones: []
                            },
                            question_6: {
                                id: `w`,
                                type: 'BooleanResult',
                                question: `The ratio of total illuminance to the reference illuminance (line v) is less than or equal to 150%. (NA7.6.1.2.2(d)1B)`,
                                zones: []
                            },
                            question_7: {
                                id: `x`,
                                type: 'Boolean',
                                question: `The control stage does not cycle on and off between dim and undimmed while daylight illuminance remains constant (NA7.6.1.2.2(d)2)`,
                                zones: []
                            },
                            question_8: {
                                id: `y`,
                                type: 'Boolean',
                                question: `Only the luminaires in the daylit zones are affected by daylight control. (NA7.6.1.2.2(d)3)`,
                                zones: []
                            },
                            question_8_1: {
                                type: 'Text',
                                text: `Second stage of control (partial daylight test)`,
                            },
                            question_8_2: {
                                id: ``,
                                type: 'Boolean',
                                question: `There is only 1 control step between ON and OFF?`,
                                zones: []
                            },
                            question_9: {
                                id: `z`,
                                type: 'Number',
                                question: `Enter the total illuminance (combined daylight and electric light illuminance) in footcandles (fc) measured at the reference location just after the second stage of control dims or shuts off a stage of lighting (NA7.6.1.2.2(d)1)`,
                                zones: []
                            },
                            question_10: {
                                id: `aa`,
                                type: 'BooleanResult',
                                question: `The total illuminance (line z) is greater than or equal to the reference illuminance (line d). (NA7.6.1.2.2(d)1A, Section 130.1(d)3B) Enter yes (Y) or no (N).`,
                                zones: []
                            },
                            question_11: {
                                id: `bb`,
                                type: 'Percentage',
                                question: `Calculate the ratio of total illuminance to the reference illuminance in %. ([line z / line d] x 100)`,
                                zones: []
                            },
                            question_12: {
                                id: `cc`,
                                type: 'BooleanResult',
                                question: `The ratio of total illuminance to the reference illuminance (line bb) is less than or equal to 150%. (NA7.6.1.2.2(d)1B) Enter yes (Y) or no (N).`,
                                zones: []
                            },
                            question_13: {
                                id: `dd`,
                                type: 'Boolean',
                                question: `The control stage does not cycle on and off between dim and undimmed while daylight illuminance remains constant. (NA7.6.1.2.2(d)2) Enter yes (Y) or no (N).`,
                                zones: []
                            },
                            question_14: {
                                id: `ee`,
                                type: 'Boolean',
                                question: `Only the luminaires in the daylit zones are affected by daylight control. (NA7.6.1.2.2(d)3) Enter yes (Y) or no (N).`,
                                zones: []
                            },
                            question_14_1: {
                                type: 'Text',
                                text: `Third stage of control (partial daylight test)`,
                            },
                            question_14_2: {
                                id: ``,
                                type: 'Boolean',
                                question: `There is only 2 control steps between ON and OFF?`,
                                zones: []
                            },
                            question_15: {
                                id: `ff`,
                                type: 'Number',
                                question: `Enter the total illuminance (combined daylight and electric light illuminance) in footcandles (fc) measured at the reference location just after the third stage of control dims or shuts off a stage of lighting (NA7.6.1.2.2(d)1)`,
                                zones: []
                            },
                            question_16: {
                                id: `gg`,
                                type: 'BooleanResult',
                                question: `The total illuminance (line ff) is greater than or equal to the reference illuminance (line d). (NA7.6.1.2.2(d)1A, Section 130.1(d)3B)`,
                                zones: []
                            },
                            question_17: {
                                id: `hh`,
                                type: 'Percentage',
                                question: `Calculate the ratio of total illuminance to the reference illuminance in %. ([line ff / line d] x 100)`,
                                zones: []
                            },
                            question_18: {
                                id: `ii`,
                                type: 'BooleanResult',
                                question: `The ratio of total illuminance to the reference illuminance (line hh) is less than or equal to 150%. (NA7.6.1.2.2(d)1B)`,
                                zones: []
                            },
                            question_19: {
                                id: `jj`,
                                type: 'Boolean',
                                question: `The control stage does not cycle on and off between dim and undimmed while daylight illuminance remains constant. (NA7.6.1.2.2(d)2)`,
                                zones: []
                            },
                            question_20: {
                                id: `kk`,
                                type: 'Boolean',
                                question: `Only the luminaires in the daylit zones are affected by daylight control. (NA7.6.1.2.2(d)3)`,
                                zones: []
                            },
                        }
                    },
                    step_5: {
                        name: `Step 5: Verify time delay. (NA7.6.1.2.2(e))`,
                        questions: {
                            question_1: {
                                id: `ll`,
                                type: 'Boolean',
                                question: `The time delay automatically resets to normal mode within 60 minutes. (NA7.6.1.2.2(e)1, Section 110.9(b)2A)`,
                                zones: []
                            },
                            question_2: {
                                id: `mm`,
                                type: 'Empty',
                                question: `Set the normal mode time delay to at least 3 minutes (NA7.6.1.2.2(e)2)`,
                                zones: []
                            },
                            question_3: {
                                id: `nn`,
                                type: 'Boolean',
                                question: `There is at least a 3-minute time delay between when illuminance exceeds the setpoint for a given dimming stage and when the control dims or switches off the controlled lights (NA7.6.1.2.2(e)3)`,
                                zones: []
                            }
                        }
                    },

                },
                comments: '',
                result: false,
            },
        }
    },

    methods: {
        functionalTestEvaluation() {

            if (!this.testIsReady) return;

            this.form.functional_test.result = true;

            if (this.form.functional_test.zones.length == 0) {
                this.form.functional_test.result = false;
            }

            _.each(this.form.functional_test.zones, (zone, index) => {

                var steps = this.form.functional_test.steps;

                // Steps
                var s1Questions = steps.step_1.questions;
                var s2Questions = steps.step_2.questions;
                var s3Questions = steps.step_3.questions;
                var s4Questions = steps.step_4.questions;
                var s5Questions = steps.step_5.questions;

                var row_A = s1Questions.question_1.zones[index].answer;
                var row_B = s1Questions.question_2.zones[index].answer;
                var row_D = s2Questions.question_2.zones[index].answer;

                var row_F = s2Questions.question_4.zones[index].answer;
                var row_G = s2Questions.question_4.zones[index].answer;

                // Line B Counting can be only selected if Line A is SW.
                if (row_A == 'SW') {
                    var _index = s1Questions.question_2.options.indexOf('C')
                    if (_index < 0) {
                        s1Questions.question_2.options.unshift('C')
                    }
                } else {
                    var _index = s1Questions.question_2.options.indexOf('C');
                    if (_index >= 0) {
                        s1Questions.question_2.options.splice(_index, 1);
                    }
                }

                // Line E, K
                if (row_B == 'C' || row_B == 'CS') {

                    // Line E
                    s2Questions.question_3.zones[index].answer = 'N/A';
                    s2Questions.question_3.zones[index].disabled = true;

                    // Line K
                    s3Questions.question_4.zones[index].answer = 'N/A';
                    s3Questions.question_4.zones[index].disabled = true;

                } else {

                    // Line E
                    if (s2Questions.question_3.zones[index].answer == 'N/A') {
                        s2Questions.question_3.zones[index].answer = 0;
                        s2Questions.question_3.zones[index].disabled = false;
                    }

                    // Line K
                    if (s3Questions.question_4.zones[index].answer == 'N/A') {
                        s3Questions.question_4.zones[index].answer = 0;
                        s3Questions.question_4.zones[index].disabled = false;
                    }

                }

                // Line G
                if (s1Questions.question_1.zones[index].answer == 'SW') {
                    s2Questions.question_5.zones[index].answer = 'N/A';
                    s2Questions.question_5.zones[index].disabled = true;
                } else if (s2Questions.question_5.zones[index].answer == 'N/A') {
                    s2Questions.question_5.zones[index].answer = '';
                    s2Questions.question_5.zones[index].disabled = false;
                }
                var row_G = s2Questions.question_5.zones[index].answer;

                // Line I
                var row_H = s3Questions.question_1.zones[index].answer;
                var row_D = s2Questions.question_2.zones[index].answer;
                var result = (row_H / row_D)
                var row_I = s3Questions.question_2.zones[index].answer = this.isValidNumber(result) ? result : 0;

                // Line J
                var row_J = s3Questions.question_3.zones[index].answer = (row_I > 1.5);

                // Line L
                if (row_B == 'CS' || row_B == 'VA' || row_B == 'W') {

                    // Line L
                    s3Questions.question_5.zones[index].answer = 'N/A';
                    s3Questions.question_5.zones[index].disabled = true;

                } else {
                    if (s3Questions.question_5.zones[index].answer == 'N/A') {
                        s3Questions.question_5.zones[index].answer = 0;
                        s3Questions.question_5.zones[index].disabled = false;
                    }
                }
                var row_L = s3Questions.question_5.zones[index].answer;

                // Line  M
                if (row_B == 'C' || row_B == 'VA' || row_B == 'W') {

                    s3Questions.question_6.zones[index].answer = 'N/A';
                    s3Questions.question_6.zones[index].disabled = true;

                } else {
                    if (s3Questions.question_6.zones[index].answer == 'N/A') {
                        s3Questions.question_6.zones[index].answer = 0;
                        s3Questions.question_6.zones[index].disabled = false;
                    }
                    var row_M = s3Questions.question_6.zones[index].answer;
                    if (row_M[0] != '.' && (isNaN(row_M) || row_M < 0 || row_M > 1)) {
                        s3Questions.question_6.zones[index].answer = '';
                    }
                }

                // Line N
                if (row_B == 'C') {
                    s3Questions.question_7.zones[index].answer = row_L;
                } else if (row_B == 'CS') {
                    s3Questions.question_7.zones[index].answer = this.isValidNumber(row_M) ? row_M : 0;
                } else {
                    var row_E = s2Questions.question_3.zones[index].answer;
                    var row_K = s3Questions.question_4.zones[index].answer;
                    var result = (1 - (row_K / row_E))
                    s3Questions.question_7.zones[index].answer = this.isValidNumber(result) ? result : 0;
                }
                var row_N = s3Questions.question_7.zones[index].answer;

                // Line O
                var porcentageOfReduction = this.isParking ? 1 : .65
                var row_O = s3Questions.question_8.zones[index].answer = (row_N >= porcentageOfReduction);

                // Line P
                var row_P = s3Questions.question_9.zones[index].answer;

                var row_Q = s3Questions.question_10.zones[index].answer;

                if (s4Questions.question_1.zones[index].answer >= 1 && s4Questions.question_1_1.zones[index].answer == true) {
                    this.form.functional_test.result = false;
                }
                if (s4Questions.question_1.zones[index].answer >= 2 && s4Questions.question_8_2.zones[index].answer == true) {
                    this.form.functional_test.result = false;
                }
                if (s4Questions.question_1.zones[index].answer >= 3 && s4Questions.question_14_2.zones[index].answer == true) {
                    this.form.functional_test.result = false;
                }

                // First Stage = Disable or Enable From Line S to KK
                if (s4Questions.question_1_1.zones[index].answer == true) {
                    for (var i = 2; i <= 8; i++) {
                        s4Questions['question_' + i].zones[index].display = false
                    }
                    s4Questions.question_8_2.zones[index].display = false
                    s4Questions.question_8_2.zones[index].answer = true
                } else {
                    for (var i = 2; i <= 8; i++) {
                        s4Questions['question_' + i].zones[index].display = true
                    }
                    s4Questions.question_8_2.zones[index].display = true
                    s4Questions.question_14_2.zones[index].display = true
                }

                // Second Stage = Disable or Enable From Line Z to KK
                if (s4Questions.question_8_2.zones[index].answer == true) {
                    for (var i = 9; i <= 14; i++) {
                        s4Questions['question_' + i].zones[index].display = false
                    }
                    s4Questions.question_14_2.zones[index].display = false
                    s4Questions.question_14_2.zones[index].answer = true
                } else {
                    for (var i = 9; i <= 14; i++) {
                        s4Questions['question_' + i].zones[index].display = true
                    }
                    s4Questions.question_14_2.zones[index].display = true
                }

                // Third Stage = Disable or Enable From Line FF to KK
                if (s4Questions.question_14_2.zones[index].answer == true) {
                    for (var i = 14; i <= 20; i++) {
                        s4Questions['question_' + i].zones[index].display = false
                    }
                } else {
                    for (var i = 14; i <= 20; i++) {
                        s4Questions['question_' + i].zones[index].display = true
                    }
                }

                // First Stage Control
                if (s4Questions.question_1_1.zones[index].answer == false) {

                    // Line U
                    var row_T = s4Questions.question_3.zones[index].answer;
                    var row_U = s4Questions.question_4.zones[index].answer = (row_T >= row_D);

                    // Line V
                    var row_V = s4Questions.question_5.zones[index].answer = (row_T / row_D);

                    // Line W
                    var row_W = s4Questions.question_6.zones[index].answer = (row_V <= 1.5);

                    // Line X
                    var row_X = s4Questions.question_7.zones[index].answer;

                    // Line Y
                    var row_Y = s4Questions.question_8.zones[index].answer;

                    if (row_U == false || row_W == false || row_X == false || row_Y == false) {
                        this.form.functional_test.result = false;
                    }
                }

                // Second Stage Control
                if (s4Questions.question_8_2.zones[index].answer == false) {

                    // Line Z
                    var row_Z = s4Questions.question_9.zones[index].answer;

                    // Line AA
                    var row_AA = s4Questions.question_10.zones[index].answer = (row_Z >= row_D);

                    // Line BB
                    var row_BB = s4Questions.question_11.zones[index].answer = (row_Z / row_D);

                    // Line CC
                    var row_CC = s4Questions.question_12.zones[index].answer = (row_BB <= 1.5);

                    // Line DD
                    var row_DD = s4Questions.question_13.zones[index].answer;

                    // Line EE
                    var row_EE = s4Questions.question_14.zones[index].answer;

                    if (row_AA == false || row_CC == false || row_DD == false || row_EE == false) {
                        this.form.functional_test.result = false;
                    }
                }

                // Third Stage Control
                if (s4Questions.question_14_2.zones[index].answer == false) {

                    // Line FF
                    var row_FF = s4Questions.question_15.zones[index].answer;

                    // Line GG
                    var row_GG = s4Questions.question_16.zones[index].answer = (row_FF >= row_D);

                    // Line HH
                    var row_HH = s4Questions.question_17.zones[index].answer = (row_FF / row_D);

                    // Line II
                    var row_II = s4Questions.question_18.zones[index].answer = (row_HH <= 1.5);

                    // Line JJ
                    var row_JJ = s4Questions.question_19.zones[index].answer;

                    // Line KK
                    var row_KK = s4Questions.question_20.zones[index].answer;

                    if (row_GG == false || row_II == false || row_JJ == false || row_KK == false) {
                        this.form.functional_test.result = false;
                    }
                }

                // Line LL
                var row_LL = s5Questions.question_1.zones[index].answer;

                // Line NN
                var row_NN = s5Questions.question_3.zones[index].answer;

                if (row_LL == false || row_NN == false) {
                    this.form.functional_test.result = false;
                }

            })
        },

    },
}
